export default __webpack_public_path__ + "static/media/mosfet.41868d08.svg";